<template>
    <ListingSettingsHeader
        :filters="filters"
        :searchable="searchable"
        :searchValue="searchValue"
        @selectFilter="updateActiveFilters"
        @search="search"
    >
        <template #filters>
            <component
                :is="activeFilter.component"
                v-for="activeFilter in getActiveFilters"
                v-bind="activeFilter"
                :key="activeFilter.code"
                class="listing-table-filters__item"
                :filter="activeFilter"
                @update:displayDropdown="
                    (value) => {
                        activeFilter.displayDropdown = value;
                    }
                "
                @updateFilter="(values) => updateFilter(activeFilter, values)"
                @removeFilter="updateActiveFilters(activeFilter, false)"
            />
        </template>
    </ListingSettingsHeader>
</template>

<script>
import ListingSettingsHeader from 'vcomponents/common/listing/header/ListingSettingsHeader.vue';

export default {
    components: { ListingSettingsHeader },
    props: {
        filters: {
            type: Array,
            required: true,
        },
        searchable: {
            type: Boolean,
            default: false,
        },
        searchValue: {
            type: String,
            required: true,
        },
    },
    computed: {
        getActiveFilters() {
            return this.filters.filter((filter) => filter.isActive);
        },
    },
    methods: {
        updateFilter(filterToUpdate, values) {
            if (values.length === 0) {
                this.updateActiveFilters(filterToUpdate, false);
            } else {
                const orderedValues = filterToUpdate.options
                    .filter((option) => values.includes(option.id))
                    .map(function (option) {
                        return option.id;
                    });
                filterToUpdate.value = orderedValues;
                filterToUpdate.optionsSelected = orderedValues;
                this.$emit('updateFilter', filterToUpdate);
            }
        },
        updateActiveFilters(filterToUpdate, isActive) {
            filterToUpdate.isActive = typeof isActive !== 'undefined' ? isActive : true;
            if (!filterToUpdate.isActive) {
                filterToUpdate.value = [];
                filterToUpdate.optionsSelected = [];
                this.$emit('removeActiveFilters', filterToUpdate);
            } else {
                filterToUpdate.displayDropdown = true;
                this.$emit('addActiveFilters', filterToUpdate);
            }
        },
        search(value) {
            this.$emit('search', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.listing-table-actions__filters {
    border: none;
}
</style>
